import { StandaloneComponent } from '@/types/component';

// Elle specific component

const FrontCoverstory: StandaloneComponent = () => null;

export default FrontCoverstory;
